import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import CreateRequestModal from "./CreateRequestModal";
import RequestInformationModal from "./RequestInformationModal";
import { requestsMockData } from "./mockData";

const RequestsList = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const userRole = localStorage.getItem("userRole");
  const isSupervisor = userRole?.toLowerCase() === "supervisor";
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    type: null,
    status: null,
  });

  const initialData = requestsMockData;

  const [displayData, setDisplayData] = useState(initialData);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleSearch = () => {
    let filtered = initialData.filter((item) => {
      const matchStart = !filters.startDate || item.date >= filters.startDate;
      const matchEnd = !filters.endDate || item.date <= filters.endDate;
      const matchType = !filters.type || item.typeValue === filters.type.value;
      const matchStatus =
        !filters.status || item.statusValue === filters.status.value;
      return matchStart && matchEnd && matchType && matchStatus;
    });
    setDisplayData(filtered);
  };

  const handleReset = () => {
    setFilters({
      startDate: "",
      endDate: "",
      type: null,
      status: null,
    });
    setDisplayData(initialData);
  };

  const columns = [
    { label: "ID", key: "id", className: "ps-4", style: { width: "80px" } },
    {
      label: "Created Date",
      key: "createdDate",
      render: (item) => (
        <div className="fs-12">
          <div className="fw-medium text-black">{item.displayDate}</div>
          <div className="text-muted">{item.time}</div>
        </div>
      ),
    },
    {
      label: "Type",
      key: "type",
      render: (item) => (
        <Badge
          bg="light"
          className="text-primary fw-bold border"
          style={{
            backgroundColor: "#F0F7FF",
            borderColor: "#D0E7FF",
            fontSize: "11px",
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    {
      label: "Amount",
      key: "amount",
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.amount} SGD</span>
      ),
    },
    {
      label: "Amended",
      key: "amended",
      render: (item) => (
        <Badge
          bg="light"
          className="text-muted px-3 py-1 border rounded"
          style={{ fontSize: "11px", backgroundColor: "#F8F9FA" }}
        >
          {item.amended}
        </Badge>
      ),
    },
    {
      label: "Status",
      key: "status",
      render: (item) => {
        let color = "#667085"; // default Gray
        let bgColor = "#F8F9FA";
        let borderColor = "#EAECF0";

        if (item.statusValue === "new") {
          color = "#344054";
          bgColor = "#F2F4F7";
        } else if (item.statusValue === "inprogress") {
          color = "#B54708";
          bgColor = "#FFFAEB";
          borderColor = "#FEDF89";
        } else if (item.statusValue === "rejected") {
          color = "#B42318";
          bgColor = "#FEF3F2";
          borderColor = "#FECDCA";
        } else if (item.statusValue === "done") {
          color = "#027A48";
          bgColor = "#ECFDF3";
          borderColor = "#ABEFC6";
        }

        return (
          <Badge
            bg="light"
            className="px-3 py-1 border rounded"
            style={{
              fontSize: "11px",
              color: color,
              backgroundColor: bgColor,
              borderColor: borderColor,
            }}
          >
            {item.status}
          </Badge>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      className: "pe-4 text-center",
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center gap-3">
          <button
            className="btn btn-xs p-0 border-0 bg-transparent text-muted"
            title="View Details"
            onClick={() => {
              setSelectedRequest(item);
              setIsUpdateMode(false);
              setShowViewModal(true);
            }}
          >
            <i className="far fa-eye fs-14"></i>
          </button>
          {isSupervisor && item.typeValue === "updateCashDrawer" && (
            <button
              className="btn btn-xs p-0 border-0 bg-transparent text-primary"
              title="Update Status"
              onClick={() => {
                setSelectedRequest(item);
                setIsUpdateMode(true);
                setShowViewModal(true);
              }}
            >
              <i className="fas fa-edit fs-14"></i>
            </button>
          )}
        </div>
      ),
    },
  ];


  const typeOptions = [
    { label: "Replenishment (Vault to Cash)", value: "replenishment" },
    { label: "Withdrawal (Cash to Vault)", value: "withdrawal" },
    { label: "Update Cash Drawer", value: "updateCashDrawer" },
  ];

  const statusOptions = [
    { label: "New", value: "new" },
    { label: "In Progress", value: "inprogress" },
    { label: "Rejected", value: "rejected" },
    { label: "Done", value: "done" },
  ];

  return (
    <div className="container-fluid">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
        <h2 className="fw-bold text-black mb-0 fs-24">Requests</h2>
      </div>
      <div className="card mb-4" style={{ borderRadius: "10px" }}>
        <div className="card-body p-3">
          <Row className="g-2 align-items-center">
            <Col xl={2} lg={3} md={6}>
              <CommonInput
                type="date"
                placeholder="Start Date"
                value={filters.startDate}
                onChange={(e) =>
                  handleFilterChange("startDate", e.target.value)
                }
              />
            </Col>
            <Col xl={2} lg={3} md={6}>
              <CommonInput
                type="date"
                placeholder="End Date"
                value={filters.endDate}
                onChange={(e) => handleFilterChange("endDate", e.target.value)}
              />
            </Col>
            <Col xl={2} lg={3} md={6}>
              <CommonSelect
                placeholder="Select type"
                options={typeOptions}
                value={filters.type}
                onChange={(val) => handleFilterChange("type", val)}
              />
            </Col>
            <Col xl={2} lg={3} md={6}>
              <CommonSelect
                placeholder="Select status"
                options={statusOptions}
                value={filters.status}
                onChange={(val) => handleFilterChange("status", val)}
              />
            </Col>
            <Col md="auto" className="d-flex gap-2">
              <CommonButton onClick={handleReset} variant="outline">
                <i className="flaticon-381-repeat-1"></i>
              </CommonButton>
              <CommonButton onClick={handleSearch}>
                <i className="flaticon-381-search-1 fs-18 text-white"></i>
              </CommonButton>
            </Col>
            {localStorage.getItem("userRole") === "Teller" && (
              <Col md="auto" className="ms-auto">
                <CommonButton
                  className="px-4"
                  onClick={() => setShowCreateModal(true)}
                >
                  <i className="fa fa-plus me-2"></i> Create Request
                </CommonButton>
              </Col>
            )}
          </Row>
        </div>
      </div>
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={displayData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>

      <CreateRequestModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
      />

      <RequestInformationModal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        request={selectedRequest}
        isUpdate={isUpdateMode}
      />
    </div>
  );
};

export default RequestsList;
